import { DocumentGroup } from "@/modules/documentGroup/documentGroup.types";
import { baseApi } from "@/api/baseApi";
import { DOCUMENT_GROUP_TAGS } from "./documentGroup.constraints";

export const documentGroupApi = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getDocumentGroupsDetails: builder.query<DocumentGroup[], string[]>({
      providesTags: (_result, _error, ids) => ids.map(id => ({ type: DOCUMENT_GROUP_TAGS.DOCUMENT_GROUP_TAG, id })),
      transformResponse: (response: { groups: DocumentGroup[] }) => response.groups,
      query: ids => ({
        params: {
          document_group_ids: ids,
        },
        url: "/pf-mainweb/document/document-groups/",
        method: "GET",
      }),
    }),
    createDocumentGroup: builder.mutation<void, { name: string; parent_fse_id?: string; items: string[] }>({
      invalidatesTags: [DOCUMENT_GROUP_TAGS.DOCUMENT_GROUP_TAG],
      query: data => ({
        url: "/pf-mainweb/document/document-groups/create",
        method: "POST",
        data,
      }),
    }),
  }),
});

export const { useCreateDocumentGroupMutation, useLazyGetDocumentGroupsDetailsQuery } = documentGroupApi;
